"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openLayer = void 0;
const openLayer = (params, extraParams, featureAppConfiguration, layerManager, render) => {
    const closeFnWrapper = {};
    let handle;
    switch (params.layer) {
        case 'content':
            handle = layerManager.openContentLayerV2(render(extraParams, featureAppConfiguration, closeFnWrapper), {}, {
                closeButtonLabel: 'Close',
                contentHeadline: '',
                userCloseable: params.userClosable,
                shimBackgroundType: params.shimBackgroundType,
                disableReturnFocus: params.disableReturnFocus,
            });
            break;
        case 'focus':
            handle = layerManager.openFocusLayer(render(extraParams, featureAppConfiguration, closeFnWrapper), {}, {
                size: params.size,
                userCloseable: params.userClosable,
                shimBackgroundType: params.shimBackgroundType,
                disableReturnFocus: params.disableReturnFocus,
            });
            break;
        case 'interaction':
            handle = layerManager.openInteractionLayer(render(extraParams, featureAppConfiguration, closeFnWrapper), {}, {
                size: params.size,
                disableReturnFocus: params.disableReturnFocus,
                userCloseable: params.userClosable,
                shimBackgroundType: params.shimBackgroundType,
            });
            break;
    }
    closeFnWrapper.closeLayer = () => {
        handle.close();
    };
};
exports.openLayer = openLayer;
//# sourceMappingURL=openLayer.js.map